﻿<script>
import {defineComponent, ref, computed, onMounted} from "vue";
import DropdownMenuItem from "./DropdownMenuItem2ComponentDesktop.vue";

// Это все надо для рекурсивности. (name заданный отдельно срабатывает через раз)
export default defineComponent({
  name: "DropdownMenuContentDesktop",
  components: {
    DropdownMenuItem,
  },
  props: {
    items: Array,
    keyTag: String,
    keyChildren: String,
    keyText: String,
    keyDivider: String,
    keyHref: String,
    keyIsLocalUrl: String,
  },
  setup(props, {emit}) {
// const emit = defineEmits(["click"]);

    const submenuTarget = ref("end");
    const activeItemSubmenuShown = ref(null);
    const menuRef = ref(null);
    const submenuRef = ref(null);
    const endRef = ref(null);
    const addScrollPadding = ref(false);
    
    onMounted(() => {
      if (!menuRef.value) return;
      addScrollPadding.value = menuRef.value.scrollHeight > menuRef.value.offsetHeight;
    });

    const someItemsHaveChildren = computed(() => {
      return props.items.some(item => item.items?.length > 0);
    });
    
    const showSubmenu = computed(() => {
      return activeItemSubmenuShown.value && 
          activeItemSubmenuShown.value.items && 
          activeItemSubmenuShown.value.items.length > 0;
    });

    const setSubmenu = (item) => {
      // todo 12325 определение стороны пока не работает как надо и приводит к кошмарным результатам по юзабилити.      
      // const {left: endLeft} = endRef.value.getBoundingClientRect();
      // if(window.innerWidth > endLeft + 280) {
      //   submenuTarget.value = "end";
      // } else {
      //   const {right: startEnd} = startRef.value.getBoundingClientRect();
      //   if (startEnd > 280) {
      //     submenuTarget.value = "start";
      //   }
      // }

      submenuTarget.value = "end";      
      if(item.items?.length > 0) {
        activeItemSubmenuShown.value = item;
      } else {
        clearSubmenu();
      }
    };

    let clearSubmenuTimeout;
    function clearSubmenu() {
      if(!activeItemSubmenuShown.value) {
        return;
      }
      clearTimeout(clearSubmenuTimeout)
      clearSubmenuTimeout = setTimeout(() => {
        activeItemSubmenuShown.value = null;
      }, 200);
    }

    function emitClick(item) {
      emit("click", item);
    }

    const onMouseOverSubmenu = () => {
      clearTimeout(clearSubmenuTimeout);
    };


    return {
      addScrollPadding,
      endRef,
      submenuTarget,
      activeItemSubmenuShown,
      menuRef,
      submenuRef,
      someItemsHaveChildren,
      showSubmenu,
      setSubmenu,
      clearSubmenu,
      emitClick,
      onMouseOverSubmenu,
    };
  },
})

</script>

<template>
  <div class="dropdown-menu-2">
    <div class="dropdown-menu__layout"
         :class="{'dropdown-menu__layout_sub': false, 'dropdown-menu__layout_inverse': false}">
      <ul class="dropdown-menu__menu" :class="{'dropdown-menu__menu_pad': addScrollPadding}" ref="menuRef" @mouseover="clearSubmenu">
        <DropdownMenuItem v-for="(item, ix) in items" 
                           :key="ix" 
                           :item="item"
                           :class="{active: activeItemSubmenuShown === item}"
                           @mouseover.stop="setSubmenu(item)" />
      </ul>
      <div v-if="someItemsHaveChildren" class="end" @mouseover="onMouseOverSubmenu" ref="endRef">
        <template v-if="showSubmenu && submenuTarget === 'end'">
          <DropdownMenuContentDesktop :items="activeItemSubmenuShown.items"
                               :key-tag="keyTag"
                               :key-children="keyChildren"
                               :key-text="keyText"
                               :key-divider="keyDivider"
                               :key-href="keyHref"
                               :key-is-local-url="keyIsLocalUrl" 
          />
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.dropdown-menu-2 {
  height: 100%;
  border-inline-start: 2px solid var(--main-40);
  padding-inline-start: 16px;
}

.dropdown-item-2 {
  width: 248px;
  
  &.active {
    background-color: var(--main-10);
    color: var(--white);
    
    :deep(svg) {
      color: inherit;
    }
  }
}

.dropdown-menu-2-right {
  [dir="rtl"] & {
    right: auto;
    left: 0;
  }
}

.dropdown-menu__layout {
  height: 100%;
  display: flex;
  flex-flow: row nowrap;

  &.dropdown-menu__layout_sub {
    display: flex;
    flex-flow: row nowrap;
    gap: 10px;
  }

  &.dropdown-menu__layout_inverse {
    flex-direction: row-reverse;
  }
}

.end {
  //padding-inline-end: 16px;
  margin-inline-start: 16px;
  
  &:empty {
    display: none;
  }
}

.dropdown-menu__menu {
  flex: 0 0 auto;
  min-width: 0;
  max-height: 264px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style-type: none;
  overscroll-behavior: none;
  /* todo 10450 Технически его можно добавлять через ResizeObserver */

  @supports not selector(::-webkit-scrollbar) {
      scrollbar-gutter: stable;
      scrollbar-color: var(--main-10) var(--second-50);
      scrollbar-width: thin;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-track {
    background: var(--second-50);
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: var(--main-10);
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: var(--main-10);
  }

  &.dropdown-menu__menu_pad {
    padding-inline-end: 10px; // чтобы элементы списка не касались скрола. Не если скрола нет, то это лишний паддинг.
  }
}

.dropdown-menu__divider {
  border-left: 1px solid var(--main-40);
}


</style>
